// extracted by mini-css-extract-plugin
export default {"container":"GZ-z","heading":"HZ-z","links":"IZ-z","copy":"JZ-z","subCopy":"KZ-z","linksLeft":"LZ-z","linksCenter":"MZ-z","linksRight":"NZ-z","link":"OZ-z","onlyLink":"PZ-z"};